import { useCallback } from 'react'

import { useLocation, useNavigate } from 'Pods/Shared/ContextBasedRouter'
import { STUDIO_PATH } from 'Pods/ThreeDStudio/constants'
import { resetImageGenerator } from 'Pods/ThreeDStudio/Store/actions/ui'

// Opens the Image Generator on its empty starting screen, as its nav item does. Already on
// /ai-image, the navigation replaces the entry instead of stacking a duplicate, and still
// runs so it drops a Regenerate's prefill prompt from the location state, which the
// remounted Create tab would otherwise apply again.
export default function useGenerateNewImage(onNavigate) {
  const navigate = useNavigate()
  const location = useLocation()

  return useCallback(() => {
    resetImageGenerator()
    navigate(STUDIO_PATH.IMAGE_GENERATOR, {
      replace: location?.pathname === STUDIO_PATH.IMAGE_GENERATOR,
    })
    onNavigate()
  }, [navigate, location, onNavigate])
}
